export const carouselSettings = {
  slideAmount: 1,
  perPage: 1
};
